// test26
(26 && 0);
